/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation IpDirectoryUpsertMutation($ipDirectoryId: ID, $displayName: String) {
  IpDirectoryUpsert(ipDirectoryId: $ipDirectoryId, displayName: $displayName) {
    id
    message
    status
  }
}
`
